import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditableMetadataInterface } from 'app/models/editable-metadata-interface';
import { FileClass } from 'app/models/file-class';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { MetadataEditorModalComponent } from '../metadata-editor-modal/metadata-editor-modal.component';

@Component({
  selector: 'app-metadata-editor',
  templateUrl: './metadata-editor.component.html',
  styleUrls: ['./metadata-editor.component.scss']
})
export class MetadataEditorComponent implements OnInit {

  uniqueID: string = '';

  @Input() fileClasses: FileClass[] = [];

  @Output() saved: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();

  constructor(private modalService: MDBModalService) { }

  private modalRef: MDBModalRef;

  ngOnInit(): void {
    this.uniqueID =  Math.random().toString(36).substr(2, 9);

  }

  onModalOK() {
    this.saved.emit();
  }

  onModalCancel() {
    this.cancel.emit();
  }

  show(filesToEdit: EditableMetadataInterface[]) {
    this.modalRef = this.modalService.show(MetadataEditorModalComponent, {
      ignoreBackdropClick: true,
      backdrop: false,
      animated: true,
      containerClass: 'modal fade',
      class: 'modal-dialog modal-primary modal-notify modal-lg',
      data: {
        fileClasses: this.fileClasses,
        uniqueID: this.uniqueID,
        filesToEdit: filesToEdit
      }
    });

    this.modalRef.content.savedMetadataSubject.subscribe(() => {
      this.onModalOK();
    });
    this.modalRef.content.cancelMetadataSubject.subscribe(() => {
      this.onModalCancel();
    });

  }
}
